import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { selectAuthUser } from '@games/ui';
import messages from 'intl/messages';
import MyLink from 'features/home/components/MyLink';
import NavDropdown from './NavDropdown';

export const NavAuth: React.FC = () => {
  const me = useSelector(selectAuthUser);
  const isLoggedIn = !!me && !!me.token;
  const { formatMessage } = useIntl();
  if (!isLoggedIn) {
    return (
      <li>
        <MyLink className='px-2 text-white' href='/login'>
          <FormattedMessage {...messages.login} />
        </MyLink>
      </li>
    );
  }
  return (
    <NavDropdown label={ formatMessage({ ...messages.account })}>
      <MyLink className='text-sm px-2' href='/prefs'>
        <FormattedMessage {...messages.settings} />
      </MyLink>
      <MyLink className='text-sm px-2' href='/password'>
        <FormattedMessage {...messages.changePassword} />
      </MyLink>
      <MyLink className='text-sm px-2' href='/logout'>
        <FormattedMessage {...messages.logout} />
      </MyLink>
      {me && me.username === 'barry' && (
        <MyLink className='text-sm px-2' href='/contacts'>
          <FormattedMessage {...messages.contactMessages} />
        </MyLink>
      )}
    </NavDropdown>
  );
};

export default NavAuth;
